import React, { FC } from 'react';
import { Offer } from '../../../shared/types';
import { normalizeHex } from '../../../utils/color-utils';
import { getBadgeData, replaceAmountVariable } from './badge-utils';

interface Props {
  offer: Offer;
  id?: number;
}

const Badge: FC<Props> = ({ offer, id }) => {
  let { label, bgColor, textColor } = getBadgeData(offer, id);
  if (!label || !bgColor || !textColor) {
    return null;
  }

  const resolvedLabel = replaceAmountVariable(label, offer);
  if (!resolvedLabel?.trim()) {
    return null;
  }

  return (
    <div
      data-testid="badge-wrapper"
      className="inline-flex items-center justify-center"
      style={{
        backgroundColor: normalizeHex(bgColor),
        padding: '1px 6px',
        lineHeight: '20px',
        width: 'fit-content',
        marginBottom: '6px',
      }}
    >
      <p
        className="text-[14px] font-semibold leading-[20px]"
        style={{ color: normalizeHex(textColor) }}
      >
        {resolvedLabel}
      </p>
    </div>
  );
};

export default Badge;
